import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDecimalNumberOnly]'
})
export class DecimalNumberDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const initialValue = this.el.nativeElement.value;
    
    // First, remove any non-numeric characters except decimal point
    let newValue = initialValue.replace(/[^0-9.]/g, '');
    
    // Remove leading zeros before the number
    newValue = newValue.replace(/^0+(\d)/, '$1');
    
    // If starts with decimal point, add 0 before it
    if (newValue.startsWith('.')) {
      newValue = '0' + newValue;
    }
    
    // Handle cases with multiple decimal points
    const decimalParts = newValue.split('.');
    if (decimalParts.length > 2) {
      newValue = decimalParts[0] + '.' + decimalParts.slice(1).join('');
    }
    
    // Keep only two decimal places
    newValue = newValue.replace(/^(\d*\.?\d{0,2}).*$/, '$1');
    
    this.el.nativeElement.value = newValue;
    
    if (initialValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}